<a [href]="getLink()"
   target="_self"
   [class]="getToggleClass()"
   (click)="onClick($event)"
   [attr.aria-expanded]="item?.menu && item?.menu[0].item && isOpen()">
  <span [innerHtml]="item?.text"></span>
  @if (item !== undefined && item.menu && item.menu[0].item && iconId) {
    <td-wb-icon [size]="castToString(size)"
                [iconId]="iconId" />
  }
</a>
